import { isNil } from 'lodash';
import { getFilterValueFormat } from '../../elasticsearch/utils';
import { ExploreExploreIsFilterParser } from './parsers/is';
import { ExploreFilterExistsFilterParser } from './parsers/exists';
import { ExploreFilterIsOneOfFilterParser } from './parsers/is-one-of';
import { ExploreFilterLookupFilterParser } from './parsers/lookup';
import { ExploreFilterIsBetweenFilterParser } from './parsers/is-between';
import { ExploreFilterLessThanFilterParser } from './parsers/less-than';
import { ExploreFilterGreaterThanFilterParser } from './parsers/greater-than';
import { ExploreFilterLuceneFilterParser } from './parsers/lucene';
const isRangeFilter = (filterType) => filterType === 'IS_BETWEEN' || filterType === 'GREATER_THAN' || filterType === 'LESS_THAN';
class EnhancedFilterModelManipulator {
    filterToElasticFilterParsers;
    constructor() {
        this.filterToElasticFilterParsers = [
            new ExploreExploreIsFilterParser(),
            new ExploreFilterIsBetweenFilterParser(),
            new ExploreFilterExistsFilterParser(),
            new ExploreFilterIsOneOfFilterParser(),
            new ExploreFilterLookupFilterParser(),
            new ExploreFilterLessThanFilterParser(),
            new ExploreFilterGreaterThanFilterParser(),
            new ExploreFilterLuceneFilterParser(),
        ];
    }
    convertElasticToFilter({ elasticFilter, negate = false, }) {
        const filters = this.filterToElasticFilterParsers.map(parser => parser.getFilter(elasticFilter, negate));
        // First non-null filter
        const filter = filters.find(filter => Boolean(filter));
        if (isRangeFilter(filter.type)) {
            const { gte, lt } = filter.value;
            if (!isNil(gte) && !isNil(lt))
                return filters.find(o => o?.type === 'IS_BETWEEN') ?? undefined;
            if (isNil(gte))
                return filters.find(o => o?.type === 'LESS_THAN') ?? undefined;
            if (isNil(lt))
                return filters.find(o => o?.type === 'GREATER_THAN') ?? undefined;
        }
        return filter;
    }
    convertToElastic({ filter }) {
        const matchFilter = this.filterToElasticFilterParsers
            .map(parser => parser.getElasticFilter(filter))
            .find(
        // Return the first non-null filter
        filter => Boolean(filter));
        return matchFilter;
    }
    getHumanReadableValue(filter) {
        return String(getFilterValueFormat(filter));
    }
}
export const enhancedFilterModelManipulator = new EnhancedFilterModelManipulator();
//# sourceMappingURL=model.manipulator.js.map